import React, { Component } from "react";

import Warning from "../../../img/warning.svg"

export class CyclesComplete extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="wrapper">
        <img src={Warning} alt="Warning icon." />
        <h3>Cycles complete</h3>
        <div className="button-row">
          <button className="primary" onClick={() => {
            this.props.setSection({
              id: this.props.id,
              section: "PROGRAM_OVERVIEW"
            })
            this.props.setDialogDisplay({
              id: this.props.id,
              displayDialog: false
            })
          }}>Go home</button>
        </div>
      </div>
    )
  }
}
